import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/pescheck.webp';
import screenshot_target from '../../../images/letterfunnel/brammittendorff.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Bram Mittendorff"
      firstname="Bram"
      companyname="PESCHECK"
      competition="Validata en DISA"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/brammittendorff.js